import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { UploadSessionStatus } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';

import {
  getReportStudyArchiveURL,
  getStudyArchiveURL,
} from '@/entities/assets';
import { i18n } from '@/entities/study';

type GetReportStudyDownloadsParams = {
  reportID: string;
  sourceStudyIDs: string[];
  studies: Study[];
  timezone: string;
};

export const getReportStudyDownloads = ({
  reportID,
  sourceStudyIDs,
  studies,
  timezone,
}: GetReportStudyDownloadsParams) => {
  const sourceStudies = studies.filter((study) =>
    sourceStudyIDs.includes(study.ID),
  );
  const hasAllSourceStudies = sourceStudyIDs.every((studyID) =>
    sourceStudies.some((study) => study.ID === studyID),
  );
  const studyTypes = sourceStudies.reduce<StudyType[]>(
    (types, { Type: studyType }) =>
      studyType !== StudyType.StudyType_InvalidValue &&
      studyType in i18n.studyTypes &&
      !types.includes(studyType)
        ? [...types, studyType]
        : types,
    [],
  );

  return studyTypes.map((studyType) => {
    const studiesOfType = sourceStudies.filter(
      (study) => study.Type === studyType,
    );

    return {
      studyType,
      href:
        studiesOfType.length === 1
          ? getStudyArchiveURL(studiesOfType[0].ID)
          : getReportStudyArchiveURL(reportID, studyType, timezone),
      disabled:
        !hasAllSourceStudies ||
        studiesOfType.some(
          ({
            Deleted: deleted,
            YourPermissions: permissions,
            UploadSessionStatuses: uploadSessionStatuses,
          }) =>
            deleted?.Deleted ||
            !permissions?.CanView ||
            !uploadSessionStatuses.some(
              (session) =>
                session.Status ===
                UploadSessionStatus.UploadSessionStatusSuccessful,
            ) ||
            uploadSessionStatuses.some(
              (session) =>
                session.Status !==
                  UploadSessionStatus.UploadSessionStatusSuccessful &&
                session.Status !==
                  UploadSessionStatus.UploadSessionStatusFailed &&
                session.Status !==
                  UploadSessionStatus.UploadSessionStatusCancelled,
            ),
        ),
    };
  });
};
